import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiPost } from "../../../utils/apiRequests";
import {
  GET_SCORE_LOADING,
  GET_SCORE_ERROR,
  GET_SCORE_SUCCESS,
  CLEAR_SCORE,
} from "../../../constant/actionTypes";

export const getScore = (payload) => (dispatch) => {
  dispatch({ type: GET_SCORE_LOADING });

  apiPost(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.getScore}`,
    payload,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_SCORE_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_SCORE_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_SCORE_ERROR, response: error });
    }
  );
};

export const clearScoreCard = () => (dispatch) => {
  dispatch({ type: CLEAR_SCORE });
};
